import { useCallback } from 'react';
import { DateVectorRange } from '../utils/DateVectorRange';
export var useCommonDatePickerCallbacks = function useCommonDatePickerCallbacks(_ref, _) {
  var setDirtyInternalValueVector = _ref.setDirtyInternalValueVector,
    setExternalValue = _ref.setExternalValue,
    timeSelectorValue = _ref.timeSelectorValue,
    setTimeSelectorValue = _ref.setTimeSelectorValue,
    dirtyInternalValueVector = _ref.dirtyInternalValueVector,
    externalizeValue = _ref.externalizeValue,
    enableApplyButton = _ref.enableApplyButton;
  var autoUpdateInternalValue = !enableApplyButton;
  // should be called to update the value (internal + external)
  var onDateTimeChange = useCallback(function (newValueDateVectorRange) {
    setDirtyInternalValueVector(newValueDateVectorRange);
    if (autoUpdateInternalValue) {
      setExternalValue(externalizeValue(newValueDateVectorRange));
    }
  }, [setDirtyInternalValueVector, autoUpdateInternalValue, setExternalValue, externalizeValue]);
  var onTimeSelectorValueChange = useCallback(function (newTimeSelectorValue) {
    setTimeSelectorValue(newTimeSelectorValue);
    if (autoUpdateInternalValue) {
      setExternalValue(externalizeValue(dirtyInternalValueVector, newTimeSelectorValue));
    }
  }, [setTimeSelectorValue, autoUpdateInternalValue, setExternalValue, externalizeValue, dirtyInternalValueVector]);
  var applyValue = useCallback(function () {
    setExternalValue(externalizeValue(dirtyInternalValueVector, timeSelectorValue));
  }, [setExternalValue, externalizeValue, dirtyInternalValueVector, timeSelectorValue]);
  var clearValue = useCallback(function () {
    setDirtyInternalValueVector(DateVectorRange.createFromLocalDate());
    setExternalValue(null);
  }, [setDirtyInternalValueVector, setExternalValue]);
  return {
    onDateTimeChange: onDateTimeChange,
    onTimeSelectorValueChange: onTimeSelectorValueChange,
    applyValue: applyValue,
    clearValue: clearValue
  };
};